import React from 'react';

import { YMapControlClose, YMapControlGeoLocation, YMapControlGroup, YMapControlZoom } from '@search/ymap/src/Control';
import { YMapDrawAreaPane } from '@search/ymap/src/DrawArea/Pane';
import { YMapPane } from '@search/ymap/src/Pane';
import { Button } from '@vtblife/uikit';

import { IFilter } from '../../../../view/filters/models/Filter';
import { ClassifiedFilterCollection } from '../../filters/ClassifiedFilterCollection';
import { useOfferYMapDrawArea } from '../page/useOfferYMapPageState2';
import { FilterMapAreaControls } from './FilterMapAreaControls';

export function FilterMapAreaPaneDesktop({
    onClose,
    showOffers,
    updateFilter,
    countInitial,
    filters
}: {
    filters: ClassifiedFilterCollection;
    updateFilter(filter: IFilter): void;
    countInitial?: number;
    showOffers?(): void;
    onClose?(): void;
}) {
    const {
        bounds,
        polygon,
        setBounds,
        setPolygon,
        isDrawAreaVisible,
        toggleDrawArea,
        onSubmit,
        count,
        countStr
    } = useOfferYMapDrawArea({
        updateFilter,
        filters,
        countInitial,
        submit: showOffers
    });

    return (
        <YMapPane
            isScrollZoomEnabled
            bounds={bounds}
            setBounds={setBounds}
        >
            <YMapControlGroup
                hAlign='right'
                vAlign='bottom'
                layout='vertical'
            >
                <YMapControlGeoLocation title='Моё местоположение' />
                <YMapControlZoom />
            </YMapControlGroup>
            {
                onClose ? (
                    <YMapControlGroup
                        hAlign='right'
                        vAlign='top'
                        layout='horizontal'
                    >
                        <YMapControlClose onClose={onClose} />
                    </YMapControlGroup>
                ) : null
            }
            <FilterMapAreaControls>
                <Button
                    variant={isDrawAreaVisible ? 'danger' : 'secondary'}
                    dataTest='filter-draw-area'
                    icon={isDrawAreaVisible ? 'trashbin' : 'finger-draw'}
                    size='s'
                    width={264}
                    onClick={toggleDrawArea}
                >
                    {isDrawAreaVisible ? 'Удалить область' : 'Нарисовать область'}
                </Button>
                <Button
                    variant='primary'
                    dataTest='filter-draw-area'
                    size='s'
                    disabled={count === 0}
                    onClick={onSubmit}
                >
                    {countStr}
                </Button>
            </FilterMapAreaControls>
            {isDrawAreaVisible && (<YMapDrawAreaPane
                handleDrawEnd={setPolygon}
                selectedArea={polygon}
            />)}
        </YMapPane>
    );
}
